import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { FlexBoxCenter, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Button from '@ecp/common/src/components/button/bo/Button';
import { ReactComponent as ErrorIcon } from '@ecp/common/src/assets/icon/icon__error-server.svg';

const UnauthorizedErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <ErrorIcon />
      <Spacing top={'20px'} />
      <TextBox size={'16px'} weight={'500'} color={'#333333'}>
        권한 토큰이 만료되었습니다. 화면을 리프레시 해주세요.
      </TextBox>
      <Spacing top={'50px'} />
      <FlexBoxCenter>
        <Button type={'Primary'} onClick={() => navigate('/')}>
          메인으로 가기
        </Button>
      </FlexBoxCenter>
    </Container>
  );
};

const Container = styled(FlexBoxColumn)`
  height: 100vh;
  justify-content: center;
`;

export default UnauthorizedErrorPage;
